export const PackageItemTypeCategory = {
    Common: 0,
    Realty: 1,
    Household: 2,
    Basic: 3,
    Addons: 4
}

export type PackageItemTypeCategory = typeof PackageItemTypeCategory[keyof typeof PackageItemTypeCategory]